import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { StreamState } from './types';

export const getters: GetterTree<StreamState, RootState> = {
  resolution(state) {
    return state.resolution;
  },

  getIsCameraLoading(state): boolean {
    return state.isLoading;
  },
};
